import { render, staticRenderFns } from "./editPatient.vue?vue&type=template&id=78f59560&scoped=true"
import script from "./editPatient.vue?vue&type=script&lang=js"
export * from "./editPatient.vue?vue&type=script&lang=js"
import style0 from "./editPatient.vue?vue&type=style&index=0&id=78f59560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f59560",
  null
  
)

export default component.exports